import {
  Box,
  Button,
  Flex,
  Heading,
  Icon,
  Image,
  Link,
  Stack,
  Text,
  useTheme,
  useToast
} from '@homebotapp/hb-react-component-catalog'
import notFoundSrc from 'assets/homes/img/not_found.svg'
import { useEffect, useMemo, useState } from 'react'
import { AppLayout } from '../../App/Layout/AppLayout'
import { useDispatch, useSelector } from 'react-redux'
import { setActiveNavigationTab } from '../../store/slices/navigation'
import { NAVIGATION_TAB_NAMES } from '../../types/navigation'
import { ListingGalleryTile } from '../../Components/homeSearch/ListingGalleryTile/ListingGalleryTile'
import openDoor from '../../assets/homes/img/openDoor.svg'
import recentPriceDrop from '../../assets/homes/img/priceDrop.svg'
import recentlySold from '../../assets/homes/img/recentlySold.svg'
import { defineMessages, useIntl } from 'react-intl'
import history from '../../history'
import { GoogleAutoComplete } from '../../Components/homeSearch/GoogleAutoComplete/GoogleAutoComplete'
import { CurrentSelectedLocation } from '../../Components/homeSearch/GoogleAutoComplete/state/currentSelectedLocation'
import {
  ClientEventName,
  ClientEventSource,
  FeedBase,
  GeoArea,
  GeoAreaLevel,
  MarketSource
} from '../../api/gqlaxy/gql/generated/graphql'
import { Feed } from '../../Components/homeSearch/Feed/Feed'
import { RootState } from '../../types/rootState'
import { selectHomebotListingsFeatureEnabled, selectNativeAccessFeature } from '../../store/selectors/customerProfile'
import useViewport from '../../hooks/useViewport'
import { DownloadMobileAppPromptCard } from '../../Components/homeSearch/ListingDetails/DownloadMobileAppPromptCard/Desktop/DownloadMobileAppPromptCard'
import { MobileDownloadMobileAppPromptCard } from '../../Components/homeSearch/ListingDetails/DownloadMobileAppPromptCard/Mobile/MobileDownloadMobileAppPromptCard'
import { HomeSearchFooter } from '../../Components/homeSearch/HomeSearchFooter/HomeSearchFooter'
import {
  selectAnswerDate,
  selectAnswerGoal,
  selectClientHomes,
  selectClientIsBuyer,
  selectClientIsLoadingData
} from '../../store/selectors/client'
import { useTrackingContext } from '../../providers/tracking'
import { hasCustomerToken, isAuthTokenSupported } from '../../auth'
import { fetchProfile } from '../../actions/customerProfile'
import { fetchClientData, fetchClientHomes, setCurrentClient } from '../../actions/client'
import { NoPreviewModeModal } from '../../Components/NoPreviewModeModal/NoPreviewModeModal'
import { fetchBuyerInfoData } from '../../actions'
import { selectAffordability } from '../../store/selectors/buyerInfo'
import { fetchMarketRecordsDetail } from '../../actions/marketRecords'
import { useLocation } from 'react-router'
import { PATH_HELPERS, SEARCH_PATH_HELPERS } from '../../constants/navigation'
import topographicalMapDark from '../../assets/homes/img/topo-bg-wide.svg'
import topographicalMapLight from '../../assets/homes/img/topo-bg-light.png'
import { useCreateClientEvent, useEffectOncePerSessionConditionally } from '../../hooks'
import { useCreateClientEventOnView } from '../../hooks/useCreateClientEventOnView'
import { useGetClientId } from '../../hooks/useGetClientId'
import { INITIALIZE_ROUTE, selectMarketExploreRoute } from '../../store/selectors/routes'
import { selectShouldRenderBuyerOnboarding } from '../../store/selectors/display'
import { camelizeKeys } from '../../helpers/utils'
import qs from 'qs'
import { PrequalConfirmationModal } from '../../Components/shared/PrequalConfirmationModal/PrequalConfirmationModal'
import { selectClientShouldSeeMarketsAndBuyerNavButtons } from '../../store/selectors/navigation'
import { useOpeningVideo } from '../../hooks/useOpeningVideo'
import { trackVideoMailerView } from '../../actions/trackingSource'
import { BombBomb } from '../../App/BombBomb/BombBomb'
import OpeningVideo from '../../Components/shared/OpeningVideo/OpeningVideo'
import { selectBombBombIsEnabled } from '../../store/slices/bombBomb'
import { BudgetModal } from './components/BudgetModal'
import { MarketSwitchDropdown } from './components/MarketSwitchDropdown'
import { useGetFeedsMarket } from '../../hooks/gallery/useGetFeedsMarket'
import { MarketTemperatureIndicator } from './components/MarketTemperatureIndicator'
import { selectMarket, selectMarketMetadata } from '../../store/selectors/marketRecord'
import { Link as ReactRouterLink } from 'react-router-dom'
import { LinkPill } from './components/LinkPill'
import { GalleryAlertOptInModal } from './components/GalleryAlertOptInModal'
import { WhereAreYouHouseHunting } from './components/WhereAreYouHouseHunting'
import SearchProfileOnboardingCompletionCard from './components/SearchProfileOnboardingCompletionCard'
import { BuyerOnboardingWizardV2 } from '../../Components/buyers/BuyerOnboardingWizard/components/BuyerOnboardingWizardV2'
import { useUpdateClient } from '../../hooks/listings/useUpdateClient'
import { useGetClientListingFeedsSubscribedDefault } from '../../hooks/gallery/useGetListingFeedsSubscribedDefault'
import { useCreateMarketInterest } from '../../hooks/gallery/useCreateMarketInterest'
import { useGetMarketInterest } from '../../hooks/gallery/useGetMarketInterest'
import { selectBuyerWelcomeVideoId, selectBuyerWelcomeVideoType } from '../../store/selectors/videos'
import BuyerWelcomeVideoModal from '../../Components/buyers/BuyerOnboardingWizard/components/BuyerWelcomeVideoModal'
import { MarketTemperatureIndicatorV2 } from './components/MarketTemperatureIndicatorV2'
import { OwnAHome } from '../../Components/homeSearch/ListingDetails/OwnAHome/OwnAHome'

interface Tile {
  icon: JSX.Element
  label: string
  type?: string
  onClick?: () => void
}

export const MSG = defineMessages({
  CantViewWhileImpersonatingAndClientHasNoGalleryAlertPreferenceSet: {
    id: 'ForYouContent.CantViewWhileImpersonatingAndClientHasNoGalleryAlertPreference',
    defaultMessage: 'You can’t view this page while impersonating a client who has no gallery alert preference set.'
  },
  successMessage: {
    id: 'BuyerOnboardingWizard.successMessage',
    defaultMessage: 'Search profile is 100% complete'
  },
  enterZipCode: {
    id: 'Gallery.enterZipCode',
    defaultMessage: 'Enter a ZIP code'
  },
  galleriesInZip: {
    id: 'Gallery.galleriesInZip',
    defaultMessage: 'Galleries in {zipcode}'
  },
  for: {
    id: 'Gallery.for',
    defaultMessage: 'For'
  },
  concessions: {
    id: 'Gallery.concessions',
    defaultMessage: 'Seller Concessions'
  },
  concessionsDescription: {
    id: 'ForYouContent.concessionsDescription',
    defaultMessage: 'Sellers cover part of your expenses'
  },
  recentPriceDrop: {
    id: 'Gallery.priceDrops',
    defaultMessage: 'Price Drops'
  },
  recentPriceDropDescription: {
    id: 'Gallery.recentPriceDropDescription',
    defaultMessage: 'See places with a reduced asking price'
  },
  assumables: {
    id: 'Gallery.assumableLoans',
    defaultMessage: 'Assumable Loans'
  },
  assumablesDescription: {
    id: 'Gallery.assumablesDescription',
    defaultMessage:
      "Ask your lender if you qualify for an assumable mortgage. You may be able to save by taking over the seller's low-rate loan!"
  },
  openHouses: {
    id: 'Gallery.openHouses',
    defaultMessage: 'Open Houses'
  },
  openHousesDescription: {
    id: 'Gallery.openHousesDescription',
    defaultMessage: 'See homes in person'
  },
  savedSearches: {
    id: 'Gallery.savedSearches',
    defaultMessage: 'Saved Searches'
  },
  favorites: {
    id: 'Gallery.favorites',
    defaultMessage: 'Favorites'
  },
  yourMarkets: {
    id: 'Gallery.yourMarkets',
    defaultMessage: 'Your Markets'
  },
  newlyListed: {
    id: 'Gallery.newlyListed',
    defaultMessage: 'Newly Listed'
  },
  newlyListedDescription: {
    id: 'Gallery.newlyListedDescription',
    defaultMessage: 'Be the first to check out these homes as soon as they hit the market!'
  },
  recentlySold: {
    id: 'Gallery.recentlySold',
    defaultMessage: 'Recently Sold'
  },
  recentlySoldDescription: {
    id: 'ForYouContent.recentlySoldDescription',
    defaultMessage: 'Explore to see what the market is like'
  },
  localGallery: {
    id: 'Gallery.localGallery',
    defaultMessage: 'Local Gallery'
  },
  forYou: {
    id: 'Gallery.forYou',
    defaultMessage: 'For You'
  },
  help: {
    id: 'ForYouContent.help',
    defaultMessage: "Let's find your next home"
  },
  localGalleries: {
    id: 'Gallery.localGalleries',
    defaultMessage: 'Local Galleries'
  },
  changeLocation: {
    id: 'Gallery.changeLocation',
    defaultMessage: 'Change Location'
  },
  failedChangeLocation: {
    id: 'Gallery.failedChangeLocation',
    defaultMessage: 'Failed to change feed location'
  },
  errorCreatingFeeds: {
    id: 'Gallery.errorCreatingFeeds',
    defaultMessage: 'Error creating feeds'
  },
  searchAllHomesInZip: {
    id: 'Gallery.searchAllHomesInZip',
    defaultMessage: 'Search all homes in {zipcode}'
  },
  zipCodeCantBeAdded: {
    id: 'Gallery.zipCodeCantBeAdded',
    defaultMessage: 'This ZIP code cannot be added to your favorites at this time.'
  },
  zipCodeAlreadyAddedToFavorites: {
    id: 'Gallery.zipCodeAlreadyAddedToFavorites',
    defaultMessage: 'Zipcode is already added to your favorites.'
  }
})

const LocalGalleryIcon = {
  recentPriceDrop: recentPriceDrop,
  recentlySold: recentlySold,
  assumables: recentPriceDrop,
  concessions: recentPriceDrop,
  openHouses: openDoor,
  newlyListed: recentlySold
}

export interface CurrentlySelectedZipCityState {
  zipcode: string
  city: string
  stateAbbreviation: string
}

export const formatCityName = (city: string | undefined): string => {
  if (!city) return ''
  return city
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}

export const ForYouContent = ({ match }) => {
  const queryParams = camelizeKeys(
    qs.parse(window.location.search, {
      ignoreQueryPrefix: true
    })
  )
  const intl = useIntl()
  const toast = useToast()
  const { theme } = useTheme()
  const dispatch = useDispatch()
  const location = useLocation()
  const { isMediumOrAbove, isSmall } = useViewport()
  const isImpersonating = hasCustomerToken()
  const { customerProfileId } = match.params
  const { trackingClient } = useTrackingContext()
  const clientId = useGetClientId()
  const { mutateAsync: createMarketInterest, isLoading: creatingMarketInterest } = useCreateMarketInterest()
  const [showGooglePlaceSelector, setShowGooglePlaceSelector] = useState(false)
  const hasNativeAccess = useSelector<RootState, boolean>(selectNativeAccessFeature)
  const marketsRoute = useSelector(selectMarketExploreRoute)
  const shouldRenderNewOnboarding = useSelector(selectShouldRenderBuyerOnboarding)
  const isBuyer = useSelector(selectClientIsBuyer)
  const isLoadingClientData = useSelector(selectClientIsLoadingData)
  const searchEnabled = useSelector(selectHomebotListingsFeatureEnabled)

  const homes = useSelector(selectClientHomes) || []

  const [dismissedOwnAHome, setDismissedOwnAHome] = useState(localStorage.getItem('dismissedOwnAHome') === 'true')

  useEffect(() => {
    const handleStorageChange = () => {
      setDismissedOwnAHome(localStorage.getItem('dismissedOwnAHome') === 'true')
    }

    window.addEventListener('storage', handleStorageChange)
    return () => window.removeEventListener('storage', handleStorageChange)
  }, [])

  const [showPrequalModal, setShowPrequalModal] = useState(queryParams.openPrequalModal === 'true')
  const clientCanAccessBuyerAndMarkets = useSelector(selectClientShouldSeeMarketsAndBuyerNavButtons)

  const {
    data: marketsInterest,
    refetch: refetchMarketsInterest,
    isLoading: loadingMarketsInterest,
    isFetching: fetchingMarketsInterest
  } = useGetMarketInterest({
    enabled: isBuyer
  })

  const allMarkets = useMemo(() => {
    if (marketsInterest?.markets) {
      return marketsInterest.markets.reduce(
        (acc, market) => {
          acc[`${market.geoArea.zipCode}`] = market.geoArea
          return acc
        },
        {} satisfies Record<string, GeoArea>
      )
    }
    return {}
  }, [marketsInterest?.markets])

  const clientZipcodes = useMemo(() => {
    if (marketsInterest?.markets) {
      return marketsInterest.markets
        .filter(item => item.source === MarketSource.MarketInterest)
        .map(market => market.geoArea.zipCode)
    }
    return []
  }, [allMarkets])

  const allZipcodes = useMemo(() => {
    if (marketsInterest?.markets) {
      return marketsInterest.markets.map(market => market.geoArea.zipCode)
    }
    return []
  }, [marketsInterest?.markets])

  const hasFavoriteMarkets = clientZipcodes?.length > 0
  const [currentlySelectedZipCityState, setCurrentlySelectedZipCityState] = useState<CurrentlySelectedZipCityState>({
    zipcode: '',
    city: '',
    stateAbbreviation: ''
  })

  const selectedZipCodeIsNotPartOfMarketsInterest = useMemo(() => {
    const zipcodes = marketsInterest?.markets?.map(market => market.geoArea.zipCode) || []
    return currentlySelectedZipCityState?.zipcode && !zipcodes?.includes(currentlySelectedZipCityState?.zipcode)
  }, [currentlySelectedZipCityState, marketsInterest?.markets])

  useEffect(() => {
    if (
      (!currentlySelectedZipCityState.zipcode && marketsInterest?.markets?.length > 0) ||
      (selectedZipCodeIsNotPartOfMarketsInterest && !fetchingMarketsInterest)
    ) {
      setCurrentlySelectedZipCityState({
        zipcode: marketsInterest?.markets?.[0]?.geoArea?.zipCode || '',
        city: '',
        stateAbbreviation: marketsInterest?.markets?.[0]?.geoArea?.stateAbbreviation || ''
      })
    }
  }, [marketsInterest, selectedZipCodeIsNotPartOfMarketsInterest, fetchingMarketsInterest])

  const market = useSelector(selectMarket(currentlySelectedZipCityState?.zipcode))

  const marketRecord = useSelector(() => selectMarketMetadata(market))
  const marketTemp = marketRecord?.data?.score
  const avgPrice = marketRecord?.data?.priceMedian
  const sizeInBudget = marketRecord?.sqftAfford
  const buyingTimeline = marketRecord?.timeline?.total
  const affordability = marketRecord?.affordability

  const welcomeVideoId = useSelector(selectBuyerWelcomeVideoId)
  const welcomeVideoType = useSelector(selectBuyerWelcomeVideoType)
  const [showWelcomeVideoModal, setShowWelcomeVideoModal] = useState(true)

  // search profile completion status
  const buyerGoals = useSelector(selectAnswerGoal)
  const buyerCloseDate = useSelector(selectAnswerDate)
  const buyerPricePoint = useSelector(selectAffordability)
  const buyerHasSetGoals = buyerGoals?.length > 0
  const buyerHasSetCloseDate = !!buyerCloseDate
  const buyerHasSetPricePoint = !!buyerPricePoint

  const { mutateAsync: updateClient } = useUpdateClient()
  const {
    data: clientGalleryAlertsOptInResolverData,
    isLoading: isLoadingClientGalleryAlertsOptInResolverData,
    refetch: refreshClientGalleryAlertsOptInResolverData
  } = useGetClientListingFeedsSubscribedDefault(
    {
      clientId
    },
    {
      enabled: !!clientId,
      cacheTime: 0, // Disable caching to always get the latest data
      staleTime: 0 // Disable stale time to always refetch data
    }
  )

  const [isShowingSearchProfileOnboarding, setIsShowingSearchProfileOnboarding] = useState(false)
  // video
  const bombBombIsEnabled = useSelector(selectBombBombIsEnabled)
  const { displayEmailVideo, videoType: videoSource, videoId, audience: audienceType } = useOpeningVideo()
  const [tracked, setTracked] = useState<string[]>([])
  const shouldTrackVideoView = Boolean(displayEmailVideo && !isLoadingClientData && !tracked.includes(videoId))
  const { mutateAsync: createViewedVideoEmailClientEvent } = useCreateClientEvent({ disableErrorPrompts: true })
  const displayOpeningVideo = displayEmailVideo

  if (shouldTrackVideoView) {
    const eventProperties = {
      audienceType,
      videoId,
      videoSource
    }

    dispatch(trackVideoMailerView(eventProperties, createViewedVideoEmailClientEvent))
    setTracked([...tracked, videoId])
  }

  const createViewClientEvent = useCreateClientEventOnView({
    eventName: ClientEventName.View,
    eventSource: ClientEventSource.ForYou
  })
  createViewClientEvent()

  const [showNotAuthorizedModal, setShowNotAuthorizedModal] = useState(!isAuthTokenSupported())
  const hasChangeLocationQs = location.search.includes('changeLocation')

  useEffect(() => {
    if (welcomeVideoId && welcomeVideoType) {
      setShowWelcomeVideoModal(!!welcomeVideoId && !!welcomeVideoType)
    }
  }, [welcomeVideoId, welcomeVideoType])

  useEffect(() => {
    // only run if we don't have values set yet or if markets change
    if (!currentlySelectedZipCityState?.zipcode || !currentlySelectedZipCityState?.stateAbbreviation) {
      if (hasFavoriteMarkets) {
        const firstFavMarketZip = clientZipcodes?.[0]
        const firstFavMarket = allMarkets?.[firstFavMarketZip]

        // Make sure we have actual values before setting state
        if (firstFavMarket?.zipCode && firstFavMarket?.stateAbbreviation) {
          setCurrentlySelectedZipCityState({
            zipcode: firstFavMarket.zipCode,
            city: firstFavMarket.city || '',
            stateAbbreviation: firstFavMarket.stateAbbreviation
          })
        }
      } else if (currentlySelectedZipCityState?.zipcode) {
        const market = allMarkets?.[currentlySelectedZipCityState?.zipcode]
        if (market) {
          setCurrentlySelectedZipCityState({
            zipcode: currentlySelectedZipCityState?.zipcode,
            city: market?.city,
            stateAbbreviation: market.stateAbbreviation
          })
        }
      } else {
        return
      }
    }
  }, [Object.keys(allMarkets)?.length, currentlySelectedZipCityState, clientZipcodes, market, hasFavoriteMarkets])

  const enableGetMarketFeeds =
    searchEnabled &&
    isAuthTokenSupported() &&
    !!currentlySelectedZipCityState?.zipcode &&
    !!currentlySelectedZipCityState?.stateAbbreviation &&
    (clientGalleryAlertsOptInResolverData?.client?.listingsFeedsSubscribedDefault === true ||
      clientGalleryAlertsOptInResolverData?.client?.listingsFeedsSubscribedDefault === false)

  const {
    data,
    isFetching,
    refetch: refreshFeeds
  } = useGetFeedsMarket(
    {
      input: {
        clientId,
        geoArea: {
          zipCode: currentlySelectedZipCityState?.zipcode,
          level: GeoAreaLevel.PostalCode,
          name: currentlySelectedZipCityState?.zipcode,
          stateAbbreviation: currentlySelectedZipCityState?.stateAbbreviation
        }
      }
    },
    {
      enabled: enableGetMarketFeeds,
      cacheTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      refetchOnMount: false
    }
  )

  useEffect(() => {
    if (allZipcodes?.length > 0) {
      dispatch(fetchMarketRecordsDetail(allZipcodes))
    }
  }, [allZipcodes, dispatch])

  const refreshBuyerInfoStates = () => {
    dispatch(fetchBuyerInfoData(clientId))
    dispatch(fetchClientData(clientId))
  }

  useEffect(() => {
    if (!isAuthTokenSupported()) {
      // setLoadingMarketInterests(false)
      return setShowNotAuthorizedModal(true)
    }

    refreshBuyerInfoStates()
    if (customerProfileId) {
      dispatch(fetchProfile(customerProfileId))
    }
  }, [dispatch, customerProfileId])

  useEffect(() => {
    if (clientId) {
      dispatch(setCurrentClient(clientId))
      dispatch(fetchClientData(clientId, customerProfileId))
      dispatch(fetchClientHomes(clientId))
    }
  }, [dispatch, clientId, customerProfileId])

  const galleryTiles = useMemo(() => {
    const tiles = data?.feedsMarket
      ?.filter(feed => MSG[feed?.feedType])
      .map(feed => {
        return {
          icon: (
            <Image
              h={4}
              w={4}
              loading='lazy'
              src={LocalGalleryIcon[feed?.feedType as string]}
              alt={feed?.feedType as string}
            />
          ),
          label: intl.formatMessage(MSG[feed?.feedType as string]),
          type: feed?.feedType,
          onClick: () => {
            trackingClient?.linkInteraction({
              ui_context: 'Gallery_Feed',
              descriptor: `Clicked on Feed ${feed?.feedType}`,
              action: 'Clicked',
              guid: `3GtcZMbe9HLD7YUKKiAyjg_${feed?.feedType}`
            })
            history.push(SEARCH_PATH_HELPERS.gallery.buildPath(customerProfileId, feed?.id, feed?.feedType, clientId))
          }
        }
      }) as Tile[]
    return tiles?.filter((tile, index, self) => self.findIndex(t => t?.type === tile?.type) === index)
  }, [data?.feedsMarket, clientId])

  useEffect(() => {
    dispatch(setActiveNavigationTab(NAVIGATION_TAB_NAMES.FORYOU))
  }, [dispatch])

  const onShowGooglePlaceSelector = () => {
    if (isImpersonating) {
      toast({
        description: 'Changing gallery locations on behalf of your clients is not supported at this time.',
        status: 'warning'
      })
    } else {
      setShowGooglePlaceSelector(true)
    }
  }

  useEffectOncePerSessionConditionally(
    () => {
      onShowGooglePlaceSelector()
      history.push({ search: '' })
    },
    undefined,
    hasChangeLocationQs
  )

  const onLocationAdded = async (place: CurrentSelectedLocation, placeDetails?: google.maps.places.PlaceResult) => {
    try {
      if (!isAuthTokenSupported()) {
        return
      }
      const postalCodeComponent = placeDetails.address_components.find(component =>
        component.types.includes('postal_code')
      )
      const zipCode = postalCodeComponent ? postalCodeComponent.long_name : null

      const createdMarketInterest = await createMarketInterest({
        input: {
          clientId,
          zipCode
        }
      })

      if (!hasFavoriteMarkets && buyerHasSetGoals && buyerHasSetCloseDate && buyerHasSetPricePoint) {
        toast({
          title: intl.formatMessage(MSG.successMessage),
          status: 'success'
        })
      }

      if (createdMarketInterest.createMarketInterest.id) {
        const stateAbbreviation = placeDetails.address_components.find(component =>
          component.types.includes('administrative_area_level_1')
        )?.short_name
        const city = placeDetails.address_components.find(component => component.types.includes('locality'))?.long_name
        setCurrentlySelectedZipCityState({
          zipcode: zipCode,
          city: city,
          stateAbbreviation: stateAbbreviation
        })

        setShowGooglePlaceSelector(false)
        refetchMarketsInterest()
      } else {
        toast({
          description: intl.formatMessage(MSG.zipCodeCantBeAdded),
          status: 'warning',
          duration: 4000,
          position: 'top'
        })
      }

      refreshFeeds()
    } catch (err) {
      const errorCode = err.response?.errors?.[0]?.message
      if (errorCode === 'createMarketInterest-zipCodeAlreadyExists') {
        toast({
          description: intl.formatMessage(MSG.zipCodeAlreadyAddedToFavorites),
          status: 'warning'
        })
        return
      }
      toast({
        description: intl.formatMessage(MSG.failedChangeLocation),
        status: 'error'
      })
    }
  }

  const onLocationChange = (zipCityState: CurrentlySelectedZipCityState) => {
    setCurrentlySelectedZipCityState(zipCityState)
  }

  const removeDuplicateRecentlySoldFeeds = (feeds: FeedBase[]) => {
    const firstRecentlySoldIndex = feeds.findIndex(feed => feed.feedType === 'recentlySold')
    if (firstRecentlySoldIndex === -1) return
    const secondRecentlySoldIndex = feeds.findIndex(
      (feed, i) =>
        feed.feedType === 'recentlySold' &&
        i !== firstRecentlySoldIndex &&
        feed.location?.zipCode === feeds[firstRecentlySoldIndex].location?.zipCode
    )
    if (secondRecentlySoldIndex !== -1) {
      feeds.splice(secondRecentlySoldIndex, 1)
    }
  }

  useEffect(() => {
    if (data?.feedsMarket) {
      removeDuplicateRecentlySoldFeeds(data.feedsMarket)
    }
  }, [data?.feedsMarket])

  // this logic was copied from the MarketsTab component
  const buildMarketsRoute = () => {
    if (hasCustomerToken()) {
      const impersonatedClientId: string = localStorage.getItem('impersonatedClientId') || ''
      const impersonatedClientIsBuyer: boolean = localStorage.getItem('impersonatedClientHbbAccess') === 'true'

      const buyRoute =
        impersonatedClientIsBuyer && !!impersonatedClientId
          ? PATH_HELPERS.markets.buildPath(impersonatedClientId, '/explore/map')
          : INITIALIZE_ROUTE
      return buyRoute
    } else {
      return marketsRoute
    }
  }

  const updateDefaultGalleryAlertPreference = async (selection: boolean) => {
    let updated = true
    try {
      await updateClient({
        input: {
          listingsFeedsSubscribedDefault: selection
        }
      })
      refreshClientGalleryAlertsOptInResolverData().then(() => {
        refreshFeeds()
        refreshBuyerInfoStates()
      })
    } catch (error) {
      updated = false
    }
    return updated
  }

  const linkPills = useMemo(() => {
    return (
      <Stack direction='row' spacing={2} overflowX='auto' flexWrap='nowrap'>
        <Flex flex='0 0 auto' direction='column'>
          <Stack direction='row' spacing={2}>
            {searchEnabled && (
              <LinkPill
                iconName='bookmark-magnifying-glass'
                label={isSmall ? undefined : intl.formatMessage(MSG.savedSearches)}
                to={SEARCH_PATH_HELPERS.savedSearches.buildPath(customerProfileId)}
                tracking={{
                  ui_context: 'Gallery_SavedSearch_Link',
                  descriptor: 'Clicked on Saved Search',
                  guid: '3GtpqMPqaHLD7YUKKiAyjg'
                }}
              />
            )}
            {searchEnabled && (
              <LinkPill
                iconName='heart'
                label={isSmall ? undefined : intl.formatMessage(MSG.favorites)}
                to={SEARCH_PATH_HELPERS.favoriteListings.buildPath(customerProfileId, clientId)}
                tracking={{
                  ui_context: 'Gallery_Favorites_Link',
                  descriptor: 'Clicked on Favorites',
                  guid: '3GtcZMPqaHLD7YUKKiAyjg'
                }}
              />
            )}
            {clientCanAccessBuyerAndMarkets && (
              <LinkPill
                iconName='map-marked-alt-filled'
                label={isSmall ? undefined : intl.formatMessage(MSG.yourMarkets)}
                to={buildMarketsRoute()}
                tracking={{
                  ui_context: 'Gallery_YourMarkets_Link',
                  descriptor: 'Clicked on Your Markets',
                  guid: '7mbCiLVFgWFgKreJzezdPa'
                }}
              />
            )}
          </Stack>
        </Flex>
      </Stack>
    )
  }, [intl, isSmall, searchEnabled, clientCanAccessBuyerAndMarkets, customerProfileId, clientId, buildMarketsRoute])

  const headerTitle = useMemo(() => {
    const selectedMarket = allMarkets?.[currentlySelectedZipCityState?.zipcode]
    if (selectedMarket) {
      return selectedMarket.name?.replace(/,/g, ' -')
    }
    return `${currentlySelectedZipCityState?.zipcode} - ${formatCityName(currentlySelectedZipCityState?.city)}`
  }, [allMarkets, currentlySelectedZipCityState])

  useEffectOncePerSessionConditionally(
    () => {
      setIsShowingSearchProfileOnboarding(true)
    },
    'buyerOnboarding',
    clientGalleryAlertsOptInResolverData?.client?.listingsFeedsSubscribedDefault !== null
  )

  if (clientGalleryAlertsOptInResolverData?.client?.listingsFeedsSubscribedDefault === null && isImpersonating) {
    return (
      <AppLayout loading={false} enableAgentDropdown={false} match={match}>
        <Flex
          padding={4}
          align='center'
          justify='center'
          direction='column'
          textAlign='center'
          height='100%'
          justifyContent='center'
          alignItems='center'
          minHeight='calc(60vh - #{$global-nav-height})'
        >
          <Flex width='50%'>
            <Text size='xl' textAlign='center' mt={8} mb={4}>
              {intl.formatMessage(MSG.CantViewWhileImpersonatingAndClientHasNoGalleryAlertPreferenceSet)}
            </Text>
          </Flex>
          <Image width='200px' mb={8} src={notFoundSrc} alt='Not found' />
        </Flex>
      </AppLayout>
    )
  }

  return (
    <AppLayout loading={isLoadingClientData || loadingMarketsInterest} enableAgentDropdown match={match}>
      {showPrequalModal && (
        <PrequalConfirmationModal onClose={() => setShowPrequalModal(false)} uiContext='For You Page' />
      )}

      {showNotAuthorizedModal && <NoPreviewModeModal />}
      {showGooglePlaceSelector && (
        <GoogleAutoComplete
          placeholder={intl.formatMessage(MSG.enterZipCode)}
          types={['postal_code']}
          onClose={() => setShowGooglePlaceSelector(false)}
          onPlaceSelected={onLocationAdded}
          returnPlaceDetails={true}
        />
      )}
      {bombBombIsEnabled && (
        <Box position='absolute' top='10px' right='10px' zIndex='ceiling'>
          <BombBomb />
        </Box>
      )}
      {displayOpeningVideo && (
        <Box mb='2'>
          <OpeningVideo />
        </Box>
      )}
      <Box
        mt={-2}
        pt={8}
        pb={12}
        px={[5, null, 20]}
        backgroundImage={`url(${theme.isLightThemeType ? topographicalMapLight : topographicalMapDark})`}
        backgroundSize='cover'
        backgroundBlendMode='multiply'
        backgroundColor='whiteAlpha.50'
        _dark={{
          backgroundColor: 'blackAlpha.600'
        }}
      >
        <Flex flexDirection={['column', 'column', 'row']} gap={[2, 4]} justifyContent={'space-between'} flexWrap='wrap'>
          <Box>
            <Flex pb={4} alignItems='center' justifyContent='space-between'>
              <Box width='100%'>
                <Flex flex={1} alignItems='center' justifyContent='space-between' mb={4}>
                  <Heading as='h1' size='2xl' textAlign='left' m={0} fontWeight={600}>
                    {intl.formatMessage(MSG.forYou)}
                  </Heading>
                  {isSmall && linkPills}
                </Flex>
                <Text m={0} size='xs' color='neutral.900'>
                  {intl.formatMessage(MSG.help)}
                </Text>
              </Box>
            </Flex>
            {!isSmall && linkPills}
          </Box>
          <Box mt={4} alignSelf={['center', 'center', 'flex-end']} w={['100%', '100%', 'auto']}>
            <BudgetModal />
          </Box>
        </Flex>
      </Box>

      <Box
        // @ts-ignore
        background='linear-gradient(0.25turn, var(--hb-colors-primary-500), var(--hb-colors-text-brand))'
        h='0.0625rem'
        w='100%'
        data-qa='for-you-divider'
      />

      <Box px={[5, null, 20]} mt={8}>
        {!hasFavoriteMarkets && !loadingMarketsInterest && (
          <WhereAreYouHouseHunting
            onPlaceSelected={onLocationAdded}
            setShowGooglePlaceSelector={setShowGooglePlaceSelector}
          />
        )}

        {!isImpersonating &&
          (!buyerHasSetGoals || !buyerHasSetCloseDate || !buyerHasSetPricePoint || !hasFavoriteMarkets) && (
            <SearchProfileOnboardingCompletionCard
              buyerHasSetFavoriteMarkets={hasFavoriteMarkets}
              buyerHasSetGoals={buyerHasSetGoals}
              buyerHasSetCloseDate={buyerHasSetCloseDate}
              buyerHasSetPricePoint={buyerHasSetPricePoint}
              onOpenFavoriteMarketModal={() => {
                setShowGooglePlaceSelector(true)
              }}
              setIsShowingSearchProfileOnboarding={setIsShowingSearchProfileOnboarding}
            />
          )}
        {homes.length === 0 &&
          hasFavoriteMarkets &&
          buyerHasSetGoals &&
          buyerHasSetCloseDate &&
          buyerHasSetPricePoint &&
          !dismissedOwnAHome && <OwnAHome enableDismiss={true} onDismiss={() => setDismissedOwnAHome(true)} />}
        <BuyerOnboardingWizardV2
          isShowing={
            !isImpersonating &&
            isShowingSearchProfileOnboarding &&
            clientGalleryAlertsOptInResolverData?.client &&
            clientGalleryAlertsOptInResolverData?.client?.listingsFeedsSubscribedDefault !== null &&
            (!buyerHasSetGoals || !buyerHasSetCloseDate || !buyerHasSetPricePoint)
          }
          setIsShowing={setIsShowingSearchProfileOnboarding}
          buyerHasSetGoals={buyerHasSetGoals}
          buyerHasSetCloseDate={buyerHasSetCloseDate}
          buyerHasSetPricePoint={buyerHasSetPricePoint}
          hasFavoriteMarkets={hasFavoriteMarkets}
        />
        <GalleryAlertOptInModal
          isOpen={
            !isImpersonating &&
            clientGalleryAlertsOptInResolverData?.client?.listingsFeedsSubscribedDefault === null &&
            !showWelcomeVideoModal
          }
          updateDefaultGalleryAlertPreference={updateDefaultGalleryAlertPreference}
        />
        {!isImpersonating &&
          showWelcomeVideoModal &&
          !isLoadingClientGalleryAlertsOptInResolverData &&
          clientGalleryAlertsOptInResolverData?.client?.listingsFeedsSubscribedDefault === null && (
            <BuyerWelcomeVideoModal
              handleSubmitClick={() => {
                setShowWelcomeVideoModal(false)
                refreshBuyerInfoStates()
              }}
            />
          )}
        {(hasFavoriteMarkets || currentlySelectedZipCityState?.zipcode) && !isImpersonating && (
          <Flex justifyContent='space-between' alignItems='center' mb={8} flexDirection={['column', 'column', 'row']}>
            <Heading as='h2' size='xl' textAlign='left' m={0} fontWeight={600} mb={4}>
              {headerTitle}
            </Heading>
            <Box width={['100%', '100%', 'auto']}>
              <MarketSwitchDropdown
                selectedZip={currentlySelectedZipCityState?.zipcode}
                setShowGooglePlaceSelector={setShowGooglePlaceSelector}
                favoriteMarkets={allMarkets}
                onLocationChange={onLocationChange}
              />
            </Box>
          </Flex>
        )}

        {isBuyer && marketTemp && (hasFavoriteMarkets || currentlySelectedZipCityState?.zipcode) && (
          <>
            <MarketTemperatureIndicator
              value={marketTemp}
              zipCode={currentlySelectedZipCityState?.zipcode}
              avgPrice={avgPrice}
              sizeInBudget={sizeInBudget}
              buyingTimeline={buyingTimeline}
              onSendMessageComplete={() => {
                setShowPrequalModal(true)
              }}
            />
            <Box mt={6}>
              <MarketTemperatureIndicatorV2
                zipCode={currentlySelectedZipCityState?.zipcode}
                legacyData={{ marketTemp, avgPrice, sizeInBudget, buyingTimeline, affordability }}
                onSendMessageComplete={() => {
                  setShowPrequalModal(true)
                }}
              />
            </Box>
          </>
        )}

        {searchEnabled && (
          <>
            {(hasFavoriteMarkets || currentlySelectedZipCityState?.zipcode) && (
              <Heading size='lg' color='neutral.900' mb={4} textAlign='left' fontWeight='semibold'>
                {intl.formatMessage(MSG.galleriesInZip, {
                  zipcode: currentlySelectedZipCityState?.zipcode
                })}
              </Heading>
            )}

            <Stack direction='row' spacing={2} overflowX='auto' flexWrap='nowrap' mb={8}>
              <Flex flex='0 0 auto' direction='column'>
                <Stack direction='row' spacing={2}>
                  {galleryTiles?.map((tile, index) => (
                    <ListingGalleryTile key={index} icon={tile.icon} title={tile.label} onClick={tile.onClick} />
                  ))}
                </Stack>
              </Flex>
            </Stack>

            {data?.feedsMarket?.map(feed => {
              if (!MSG[feed?.feedType]) {
                return null
              }

              return <Feed key={feed?.id} feed={feed as FeedBase} />
            })}
          </>
        )}
        {(hasFavoriteMarkets || currentlySelectedZipCityState?.zipcode) && (
          <>
            {isSmall ? (
              <Button
                width='100%'
                as={ReactRouterLink}
                colorScheme='primary'
                to={`${SEARCH_PATH_HELPERS.search.buildPath(
                  customerProfileId
                )}?postal_code=${currentlySelectedZipCityState?.zipcode}&statuses%5B0%5D=Active&statuses%5B1%5D=Coming%20Soon`}
                tracking={{
                  ui_context: 'Gallery_SearchAllHomesInZip_Card',
                  descriptor: 'Clicked on Search All Homes in Zip',
                  guid: '3GtcZMPqaHLD7YUKKiAyjg'
                }}
              >
                <Text mb={0} fontWeight='600'>
                  {intl.formatMessage(MSG.searchAllHomesInZip, {
                    zipcode: currentlySelectedZipCityState?.zipcode
                  })}
                </Text>
                <Icon name='circle-arrow-right-bts' ml={1} />
              </Button>
            ) : (
              <Link
                as={ReactRouterLink}
                to={`${SEARCH_PATH_HELPERS.search.buildPath(
                  customerProfileId
                )}?postal_code=${currentlySelectedZipCityState?.zipcode}&statuses%5B0%5D=Active&statuses%5B1%5D=Coming%20Soon`}
                tracking={{
                  ui_context: 'Gallery_SearchAllHomesInZip_Card',
                  descriptor: 'Clicked on Search All Homes in Zip',
                  guid: '3GtcZMPqaHLD7YUKKiAyjg'
                }}
                display='flex'
                alignItems='center'
                justifyContent='center'
                mb={8}
              >
                <Text mb={0}>
                  {intl.formatMessage(MSG.searchAllHomesInZip, {
                    zipcode: currentlySelectedZipCityState?.zipcode
                  })}
                </Text>
                <Icon name='circle-arrow-right-bts' ml={1} />
              </Link>
            )}
          </>
        )}
      </Box>

      {hasNativeAccess && (
        <Box margin={8}>
          {isMediumOrAbove ? (
            <DownloadMobileAppPromptCard isLandingPage={true} />
          ) : (
            <MobileDownloadMobileAppPromptCard isLandingPage={true} />
          )}
        </Box>
      )}
      <HomeSearchFooter />
    </AppLayout>
  )
}
